<template>
  <div class="export_btn" :style="style" :flex="flex">
    <el-button :loading="loading" :type="type" :round="round" :circle="circle" :size="size" @click="exportExcel">
      {{ name }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue"
import Excel from "exceljs"
import { ElButton } from "element-plus"
import { useDark, useToggle } from "@vueuse/core"

const loading = ref(false)

withDefaults(
  defineProps<{
    style: { [key: string]: string }
    name?: string
    type?: "primary" | "success" | "warning" | "danger" | "info" | "text"
    size?: "large" | "default" | "small"
    round?: boolean
    circle?: boolean
    flex?: string
  }>(),
  {
    style: () => ({}),
    name: () => "导出",
    type: () => "primary",
    size: () => "default",
    round: () => false,
    circle: () => false,
    flex: () => "dir:left main:center cross:center",
  },
)

interface SheetConfig {
  sheetName: string
  header: string[][]
  merges?: string[]
  columns: {
    key: string
    width: number
    formatter?: string
    alignment?: {
      horizontal: "left" | "center" | "right" | "fill" | "justify" | "centerContinuous" | "distributed"
      vertical: "top" | "middle" | "bottom" | "distributed" | "justify"
      wrapText: boolean
      shrinkToFit: boolean
      indent: number
      readingOrder: "rtl" | "ltr"
      textRotation: number | "vertical"
    }
  }[]
  data: any[][]
}

const data = ref<{
  fileName: string
  sheets: SheetConfig[]
}>({
  fileName: "",
  sheets: [],
})

const formatters = {
  formatDate: (value: string) => {
    const date = new Date(value)
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  },
}

const exportExcel = () => {
  console.log("exportExcel", data.value)
  if (data.value.sheets.length === 0) {
    return
  }
  loading.value = true
  const workbook = new Excel.Workbook()
  data.value.sheets.forEach(item => {
    const worksheet = workbook.addWorksheet(item.sheetName)
    // 插入多行表头
    item.header.forEach((row, rowIndex) => {
      const excelRow = worksheet.getRow(rowIndex + 1)
      row.forEach((cell, colIndex) => {
        excelRow.getCell(colIndex + 1).value = cell
      })
      excelRow.commit()
    })

    // 设置列宽
    if (item.columns) {
      item.columns.forEach((column, index) => {
        worksheet.getColumn(index + 1).width = column.width
        if (column.alignment) {
          worksheet.getColumn(index + 1).alignment = column.alignment
        }
      })
    }

    item.data.forEach((rowData, index) => {
      const formattedRow = Array.from({ length: item.columns.length }) as string[] // 初始化一个与 rowData 相同长度的数组，用于存储格式化后的数值或其他内容
      item.columns.forEach((col, colindex) => {
        const rawValue = rowData[colindex]
        if (col.formatter && formatters[col.formatter]) {
          formattedRow[colindex] = formatters[col.formatter](rawValue)
        } else {
          formattedRow[colindex] = rawValue
        }
      })
      console.log("formattedRow", formattedRow)
      worksheet.addRow(formattedRow)
    })
    // 合并单元格
    if (item.merges) {
      item.merges.forEach(merge => {
        worksheet.mergeCells(merge)
      })
    }
  })
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = `${data.value.fileName}.xlsx`
    link.click()
    window.URL.revokeObjectURL(url)
    loading.value = false
  })
}

const setData = (setdata: { fileName: string; sheets: SheetConfig[] }) => {
  data.value = setdata
}

onMounted(() => {
  const isDark = useDark()
  isDark.value = true
  useToggle(isDark)
})

defineExpose({
  setData,
})
</script>

<style lang="scss">
.export-container-masker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: none !important;
  &.show {
    display: flex !important;
    background: rgba(0, 0, 0, 0.5);
  }
}
.export_btn {
  z-index: 5;
}
.export-container {
  padding: 15px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: rgb(12 45 91);
  box-shadow: 0 0 5px 0 rgb(45 213 255);
  width: 650px;
  .export-header {
    padding: 5px;
    font-size: 16px;
    color: #fff;
    // border-bottom: 1px solid #fff;
  }
  .export-option {
    padding: 10px 0;
    font-size: 16px;
    &.desc {
      color: #fff;
      font-size: 14px;
      text-align: center;
    }
  }
  .export-footer {
    display: flex;
    justify-content: space-between;
    &.center {
      justify-content: center;
    }
    padding: 10px;
  }
}
.pft-btn {
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  &.default {
    background: #fff;
    color: #000;
  }
  &.primary {
    background: #1890ff;
    color: #fff;
  }
}
</style>
